import React from "react";
// import { FMarketListData } from "../../../data/foreign/mainBoard/types";
import { LocalizationContext } from "../../../core/localization/Localization";
import { useDisplaySingleEmementStyles } from "../../useDisplaySingleEmementStyles";
import { useAuth } from "../../../data/auth/hooks";
import { useDisplayEtfSummary } from "../../../data/reports/securityStatistics/hooks/useDisplayEtfSummary";
import { formatDateFromISO } from "../../../core/util/functions";

export interface DisplayEtfSummaryProps {
	symbol?: string;
}

export const DisplayEtfSummary: React.FunctionComponent<DisplayEtfSummaryProps> = ({
	symbol,
}) => {
	const eftSummary = useDisplayEtfSummary(symbol);

	const style = useDisplaySingleEmementStyles();
	const { getString, getDateString, getDateTimeString, getFormatedNumberString, getFormatedNumberString4, getPercentString, getPercentStringDynamic4 } = React.useContext(
		LocalizationContext
	);


	const [auth] = useAuth();

	return (
		<div className={style.root}>
			<div className={`${style.row} ${style.rowBorder}`}>
				<span className={style.label}>{getString("etfInceptionDate")}</span>
				<span className={style.value}>
					{formatDateFromISO(eftSummary?.share_class_inception_date)}
				</span>
			</div>
			<div className={`${style.row} ${style.rowBorder}`}>
				<span className={style.label}>{getString("etfYtdReturn")}</span>
				<span className={style.value}> {getPercentStringDynamic4(eftSummary?.ytd_return)}</span>
			</div>
			<div className={`${style.row} ${style.rowBorder}`}>
				<span className={style.label}>{getString("etfExpenseRatio")}</span>
				<span className={style.value}> {getPercentStringDynamic4(eftSummary?.expense_ratio_net)}</span>
			</div>
			<div className={`${style.row} ${style.rowBorder}`}>
				<span className={style.label}>{getString("etfYield")}</span>
				<span className={style.value}> {getPercentStringDynamic4(eftSummary?.yield)}</span>
			</div>
			<div className={`${style.row} ${style.rowBorder}`}>
				<span className={style.label}>{getString("etfNav")}</span>
				<span className={style.value}> {getFormatedNumberString4(eftSummary?.nav, true)}</span>
			</div>
			<div className={`${style.row} ${style.rowBorder}`}>
				<span className={style.label}>{getString("etfLastPrice")}</span>
				<span className={style.value}> {getFormatedNumberString4(eftSummary?.last_price, true)}</span>
			</div>
			<div className={`${style.row} ${style.rowBorder}`}>
				<span className={style.label}>{getString("etfTurnoverRate")}</span>
				<span className={style.value}> {getPercentStringDynamic4(eftSummary?.turnover_rate)}</span>
			</div>
			<div className={`${style.row} ${style.rowBorder}`}>
				<span className={style.label}>{getString("etfNetAssets")}</span>
				<span className={style.value}> {getFormatedNumberString4(eftSummary?.net_assets)}</span>
			</div>

		</div>
	);
};

